import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import packageSample from "../../Assets/marked-package.png";
import whiteSheets from "../../Assets/white-sheets.png";
import noMess from "../../Assets/no-mess.png";
import lightWeight from "../../Assets/light-weight.png";
import effectiveCleaning from "../../Assets/effective-cleaning.png";
import quickDissolve from "../../Assets/quick-dissolve.png";
import plasticFree from "../../Assets/plastic-free.png";
import Tilt from "react-parallax-tilt";
import WhyKlean from "../WhyKlean/WhyKlean";
import BuiltForYou from "../BuiltForYou/BuiltForYou";
import Seo, { breadcrumbSchema, productSchema } from "../Seo/Seo";

function Products() {
  return (
    <>
      <Seo
        title="Private Label Laundry Detergent Sheets"
        description="Source private label laundry detergent sheets with custom scents, fragrance-free options, perforated sheets, packaging, and bulk formats."
        path="/products"
        schema={[
          productSchema,
          breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Products", path: "/products" }]),
        ]}
      />
      <Container fluid className="products-section page-top-settings" id="products">
        <Container className="white">
          <Row>
            <h1>Private Label Laundry Detergent Sheets</h1>
            <h2 className="page-title ">
              Custom Laundry Sheets for B2B Brands
              <p>Scented, fragrance-free, perforated, and bulk-ready formats</p>
            </h2>
          </Row>
          <Row>
            <Col md={6} style={{ paddingBottom: 20 }}>
              <Tilt>
                <img
                  src={packageSample}
                  alt="Private label laundry detergent sheet paper packaging"
                  className="img-fluid"
                />
              </Tilt>
            </Col>
            <Col md={5} className="products-intro">
              <p className="products-info">
              Klean Leaf manufactures compact laundry detergent sheets for brands that need a private label product, wholesale supply, or refill-shop format. Sheets can be positioned for half-sheet or full-sheet use depending on your pack count, perforation, and customer instructions.
              </p>
              <p className="products-info">
              Choose fragrance-free, review available scent samples, or work with us to develop a custom fragrance for your market. We can also discuss formula adjustments, sheet finish, and packaging options during sampling.


              </p>
              <p className="products-info">
                Example ingredients may include Glycerol, Primary Alcohol Ethoxylate, Sodium Dodecyl Sulfate, Sodium Acetate Trihydrate, Protease, Polyvinyl alcohol, Deionized Water, Fragrance, and Starch. <strong>Formula details, fragrance, and PVA content can be discussed for your project requirements.</strong>
              </p>
            </Col>
          </Row>
        </Container>

        <Container className="products-content sheets-section my-5">
          <WhyKlean />
          <Row>
            <Col md={6} className="sheets-img">
              <figure>
                <img
                  src={whiteSheets}
                  alt="White private label laundry detergent sheets"
                  className="img-fluid"
                />
              </figure>
            </Col>
            <Col md={6} className="products-intro sheets-intro">
              <h2>Sheet Specs and Customization Options</h2>
              <div>We use just enough PVA to hold the sheet together—nothing more. While extra PVA gives a super-smooth look, it’s mostly cosmetic and has stirred debate in the eco space. Here’s our approach:</div>
              <ul>
                <li>Cleaning Power First: More PVA doesn’t improve cleaning. We focus on the active ingredients that actually get your clothes clean.</li>
                <li>Formula Positioning: PVA content and finish can be discussed based on your performance, appearance, and marketing priorities.</li>
                <li>Built to Dissolve: Our sheets stay intact until you start the wash, then disappear completely—no residue, no fuss.</li>
                <li>Custom Finish: Prefer a smoother sheet feel? We can review options during sample development.</li>
              </ul>
              <a href="/contact" className="secondary-btn mt-3">Request Samples</a>
            </Col>
          </Row>
        </Container>
      </Container>
      
      <BuiltForYou />
      <Container
        fluid
        className="products-section products-details"
        id="products"
      >
        <Container className="products-content">
          <Row>
            <h2 className="products-details-title skewed">Detergent Sheet Features for Private Label Programs</h2>
          </Row>

          <Row className="feature-wrapper">
            <Col xs={6} md={2} className="">
              <img src={noMess} className="feature-img" alt="No-mess laundry detergent sheet icon" />
            </Col>

            <Col xs={6} md={2} className="">
              <img
                src={lightWeight}
                className="feature-img"
                alt="Lightweight laundry sheet shipping icon"
              />
            </Col>

            <Col xs={6} md={2} className="">
              <img
                src={effectiveCleaning}
                className="feature-img"
                alt="Effective cleaning laundry sheet icon"
              />
            </Col>

            <Col xs={6} md={2} className="">
              <img
                src={quickDissolve}
                className="feature-img"
                alt="Quick dissolve laundry detergent sheet icon"
              />
            </Col>

            <Col xs={6} md={2} className="">
              <img
                src={plasticFree}
                className="feature-img"
                alt="Paper packaging laundry sheet icon"
              />
            </Col>
          </Row>

          <Row className="products-details-text text-center">
            <Col md={12} className="products-intro">
              <p className="products-info">
                Laundry sheets are compact, lightweight, and easier to store than traditional liquid detergent formats. This helps business buyers plan efficient cartons, shelf-ready packs, refill cartons, and e-commerce-friendly shipments.
              </p>

              <p className="products-info">
                Klean Leaf supports the full private label development process, including formula and scent review, artwork integration, packaging samples, production, and delivery coordination.
              </p>
              <a href="/solution" className="secondary-btn mt-3">See Private Label Process</a>
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}

export default Products;
